import { useCallback } from 'react';
import useVelocityClient from 'src/hooks/useVelocityClient';
import useVelocityAccountsStore from 'src/stores/useVelocityAccountsStore';

export const useUnsubscribeClients = () => {
	const velocityClient = useVelocityClient();

	const unsubscribeClients = useCallback(async () => {
		const accountStore = useVelocityAccountsStore.getState().get();

		const unsubscribeUserClientsPromises = Object.values(
			accountStore.accounts
		).map((account) => {
			return account?.client?.unsubscribe() ?? Promise.resolve();
		});
		await Promise.all(unsubscribeUserClientsPromises);

		if (velocityClient) await velocityClient.unsubscribe();
	}, [velocityClient]);

	return { unsubscribeClients };
};
